import axios from 'axios';
import {api} from '../../constants/api';
import {errors as E} from 'common/constants/errors';

export const getFileList = ({shumaId}) => dispatch => {
  const data = {selectedShumaID: parseInt(shumaId, 10)};

  return axios.post(api.GET_SHUMA_BASIC_DATA_FILES, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      return body;
    })
    .catch((err) => {
      console.error('getFileList returns error:');
      console.error(err);
    });
};
